var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn c-btn",class:[
    ("c-btn-" + _vm.mode),
    {
      'btn-primary': _vm.mode === 'primary',
      'btn-outline-primary primary-text': _vm.mode === 'transparent'
    }
  ],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('action', $event)}}},[_c('i',{class:_vm.getArrow()})])}
var staticRenderFns = []

export { render, staticRenderFns }